import styled from 'styled-components';

export const EmptyCartMessage = styled.h3`
  color: ${Styles.color.grey.one};
  display: flex;
  font-size: 1.125rem;
  font-weight: ${Styles.fontWeight.heavy};
  font-family: ${Styles.fontFamily.base};
  justify-content: center;
  text-transform: uppercase;
  padding: 0 0 1rem 0;
`;
